<template>
<div>
    <v-row>
        <v-col class="" cols="6" sm="8">
          <span 
            class="font-weight-light grey--text text-capitalize" 
            :class="{'body-1': $vuetify.breakpoint.xsOnly,'headline': $vuetify.breakpoint.smAndUp}"
          >Financials</span>
          <span class="d-block body-2 font-weight-thin">{{ $store.state.branchName }}</span>
        </v-col>
  </v-row>
  <v-card class="mb-6">
      <v-card-title class="secondary white--text pa-3" id="card-title">
      <div class="">
        <span class="">Summary</span>
      </div>
    </v-card-title>
    <v-simple-table>
    <template>
      <thead>
        <tr>
          <th class=""></th>
          <th class="text-center">Secured Sales/Invoiced Sales</th>
          <th class="text-center">Under Offer Sales/Unpaid Invoices</th>
          <th class="text-center">Total Estimated Sales</th>
        </tr>
      </thead>
      <tbody>
          <tr>
            <td class="text-center">Estate Agency Sales <v-icon style="color:black" @click="openEstateAgencySalesPopup()">mdi-information-outline</v-icon></td>
            <td class="text-center">{{toCurrency(summary.SecuredEstateAgencySalesTotal)}}</td>
            <td class="text-center">{{toCurrency(summary.UnderOfferEstateAgencySalesTotal)}}</td>
            <td class="text-center">{{toCurrency(summary.EstateAgentsSalesEstimatedTotal)}}</td>
          </tr>
          <tr>
            <td class="text-center">Lettings Sales <v-icon style="color:black" @click="openLettingsSalesPopup()">mdi-information-outline</v-icon></td>
            <td class="text-center">{{toCurrency(summary.SecuredLettingsSalesTotal)}}</td>
            <td class="text-center">{{toCurrency(summary.UnderOfferLettingsSalesTotal)}}</td>
            <td class="text-center">{{toCurrency(summary.LettingsSalesEstimatedTotal)}}</td>
          </tr>
          <tr>
            <td class="text-center "><strong>Totals</strong></td>
            <td class="text-center"><strong>{{toCurrency(summary.TotalSecured)}}</strong></td>
            <td class="text-center"><strong>{{toCurrency(summary.TotalUnderOffer)}}</strong></td>
            <td class="text-center"><strong>{{toCurrency(summary.TotalEstimated)}}</strong></td>
          </tr>
      </tbody>
    </template>
    </v-simple-table>
<p class="description"></p>
  </v-card>
  <v-card class="mb-6">
    <v-card-title class="secondary white--text pa-3" id="card-title">
      <div class="">
        <span class="">Forecast
    </span>
      </div>
    </v-card-title>
    <v-simple-table>
    <template>
      <thead>
        <tr>
          <th class=""></th>
          <th class="text-center">Estate Agency Sales</th>
          <th class="text-center">Lettings Sales</th>
          <th class="text-center">Totals</th>
        </tr>
      </thead>
      <tbody>
          <tr>
            <td class="text-center">Forecast  <v-icon style="color:black" @click="openForecastPopup()">mdi-information-outline</v-icon></td>
            <td class="text-center">{{toCurrency(salesForecast.amount)}}</td>
            <td class="text-center">{{toCurrency(lettingsForecast.amount)}}</td>
            <td class="text-center">{{toCurrency(calculateForecastTotal())}}</td>
          </tr>
          <tr>
            <td class="text-center">Difference</td>
            <td class="text-center">{{toCurrency(calculateSalesForecastDifference())}}</td>
            <td class="text-center">{{toCurrency(calculateLettingsForecastDifference())}}</td>
            <td class="text-center">{{toCurrency(calculateTotalForecastDifference())}}</td>
          </tr>
      </tbody>
    </template>
    </v-simple-table>
  </v-card>
  <Popup
      :dialog="forecastInfoPopup"
      popupTitle="Forecast"
      descriptionContent="Your forecast amounts for the month can be set on the settings page"
      @closeDialog="closeForecastPopup"
    />
    <Popup
      :dialog="estateAgencySalesInfoPopup"
      popupTitle="Estate Agency Sales"
      descriptionContent="Your confirmed estate agency sales are calculated by taking the sum of the sales fees for all sales instructions that have exchanged contracts or completed throughout the given month. The estimated estate agency fees is calculated from the sum of all sales instructions under offer in the given month."
      @closeDialog="closeEstateAgencySalesPopup"
      />
          <Popup
      :dialog="lettingsSalesInfoPopup"
      popupTitle="Lettings Sales"
      descriptionContent="Your lettings sales are calculated by taking the sum of the setup fees, management fees, contractor commissions and any other charges applied to any tenancy in the given month. he confirmed sales are the total invoices raised in the month that have been paid, and the estimated sales is the total invoiced that is yet to be paid."
      @closeDialog="closeLettingsSalesPopup"
      />
</div>
</template>

<script>
import {mapState} from 'vuex';
import Popup from './DescriptionPopupComponent';

export default {
  components : {
    Popup
  },
  data() {
    return {
      forecastInfoPopup: false,
      estateAgencySalesInfoPopup: false,
      lettingsSalesInfoPopup: false
    }
  },
  computed:{
    ...mapState({
      summary: state => state.Financials.financialSummary,
      salesForecast: state => state.Financials.salesForecast,
      lettingsForecast: state => state.Financials.lettingsForecast
    })
  },
  watch:{
    '$store.state.reportMonth': function (){
    this.$store.dispatch("Financials/getCompanySummary");
    this.$store.dispatch("Financials/getLettingsForecast");
    this.$store.dispatch("Financials/getSalesForecast");
    }
  },
  mounted() {
    this.$store.dispatch("Financials/getCompanySummary");
  },
  methods: {
    openForecastPopup(){
      this.forecastInfoPopup = true;
    },
    closeForecastPopup() {
      this.forecastInfoPopup = false
    },
    openEstateAgencySalesPopup(){
      this.estateAgencySalesInfoPopup = true;
    },
    closeEstateAgencySalesPopup() {
      this.estateAgencySalesInfoPopup = false
    },
    openLettingsSalesPopup(){
      this.lettingsSalesInfoPopup = true;
    },
    closeLettingsSalesPopup() {
      this.lettingsSalesInfoPopup = false
    },
    toCurrency: function (value) {
    if (typeof value !== "number") {
            return value;
        }
        if(this.$store.state.currencyData.CurrencyCode != undefined){
        var formatter = new Intl.NumberFormat(this.$store.state.currencyData.LocaleCode, {
            style: 'currency',
            currency: this.$store.state.currencyData.CurrencyCode,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        return formatter.format(value);
        }
        else{
          return null;
        }
    },
    calculateForecastTotal(){
      return this.salesForecast.amount + this.lettingsForecast.amount;
    },
    calculateSalesForecastDifference(){
      return this.summary.EstateAgentsSalesEstimatedTotal - this.salesForecast.amount;
    },
    calculateLettingsForecastDifference(){
      return this.summary.LettingsSalesEstimatedTotal - this.lettingsForecast.amount;
    },
    calculateTotalForecastDifference(){
      return this.calculateSalesForecastDifference() + this.calculateLettingsForecastDifference();
    },
  }
}
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:300);
.centered-input {
  text-align: center;
}
th{
  width: 25%;
}
td{
  width: 25%;
}
</style>
